import { GET_ALL_UTILITY_DATA, GET_LOCALIZATION_INFO, GET_TIMEZONES, UPDATE_LOCALIZATION_INFO, UPDATE_TIMEZONES, UPDATE_UTILITIES_STATUS, UPDATE_CONSTANTS, UPDATE_KIOSK, } from "./types";
export var getAllUtilityData = function () { return ({
    type: GET_ALL_UTILITY_DATA,
}); };
export var getLocalizationInfo = function () { return ({
    type: GET_LOCALIZATION_INFO,
}); };
export var updateLocalizationInfo = function (localization) { return ({
    type: UPDATE_LOCALIZATION_INFO,
    payload: localization,
}); };
export var getTimezones = function () { return ({
    type: GET_TIMEZONES,
}); };
export var updateTimezones = function (timezones) { return ({
    type: UPDATE_TIMEZONES,
    payload: timezones,
}); };
export function updateUtilitiesStatus(isLoading) {
    return {
        type: UPDATE_UTILITIES_STATUS,
        payload: isLoading,
    };
}
export var updateConstants = function (constants) { return ({
    type: UPDATE_CONSTANTS,
    payload: constants,
}); };
export var updateKiosk = function (kiosk) { return ({
    type: UPDATE_KIOSK,
    payload: kiosk,
}); };
